export default __webpack_public_path__ + "static/media/big_notification_bell.fb517fae.svg";